import React from "react";
import cx from "clsx";

import BldgE1Img from "@/images/tour/e1-light.svg";
import BldgE2Img from "@/images/tour/e2-light.svg";
import BldgE3Img from "@/images/tour/e3-light.svg";
import BldgE4Img from "@/images/tour/e4-light.svg";
import ArrowSvg from "@/images/shared/arrow-up.svg";
import tourData from "@/data/tour-details.json";
import { debounce } from "@/helpers";

import globalStyles from "@/styles/global.module.scss";
import styles from "./videoStopDetails.module.scss";

const ICONS = {
  "bldg-e1": BldgE1Img,
  "bldg-e2": BldgE2Img,
  "bldg-e3": BldgE3Img,
  "bldg-e4": BldgE4Img,
};

class VideoStopDetails extends React.PureComponent {
  state = {
    menuOpen: false,
    tempStopIndex: null,
  };

  componentDidMount() {
    const { stopIndex } = this.props;

    if (stopIndex) {
      this.setState({ tempStopIndex: stopIndex || null });
    }
  }

  componentDidUpdate(prevProps) {
    const { stopIndex, visible } = this.props;

    // Keep record of prev stopIndex so out animation can finish
    if (stopIndex !== prevProps.stopIndex) {
      if (stopIndex % 1 === 0) this.setState({ tempStopIndex: stopIndex });
      this.handleSetTempIndex(stopIndex);
    }
    // Close menu when leaving stop
    if (prevProps.visible && !visible) {
      this.setState({ menuOpen: false });
    }
  }

  handleSetTempIndex = debounce((tempStopIndex) => {
    this.setState({ tempStopIndex });
  }, 330);

  handleButtonClick = () => this.setState({ menuOpen: !this.state.menuOpen });

  render() {
    const { visible, isDesktop } = this.props;
    const { tempStopIndex, menuOpen } = this.state;

    const data = tourData[tempStopIndex || 0];
    const Icon = data && data.icon ? ICONS[data.icon] : null;

    if (tempStopIndex < 6 || tempStopIndex > 9.5 || tempStopIndex % 1 !== 0) {
      return null;
    }

    return (
      <div
        className={cx(
          styles.container,
          isDesktop && styles.isDesktop,
          visible ? styles.entered : styles.exited,
          menuOpen && styles.open
        )}
      >
        <div className={styles.inner}>
          <div className={cx(styles.top, styles.col)}>
            <button
              className={cx(globalStyles.buttonReset, styles.button)}
              onClick={this.handleButtonClick}
            >
              <span className={styles.buttonLabel}>{`${
                menuOpen ? "Less" : "More"
              } Details`}</span>
              <ArrowSvg
                className={cx(styles.buttonArrow, menuOpen && styles.open)}
                alt={menuOpen ? "Less" : "More"}
              />
            </button>
          </div>
          <div className={cx(styles.col, styles.middle)}>
            <div className={cx(styles.colLeft, styles.middleLeft)}>
              {data && Icon ? (
                <Icon className={styles.bldgImg} alt={data.title} />
              ) : null}
              {data ? (
                <span className={styles.header}>{data.title}</span>
              ) : null}
            </div>
            <div className={cx(styles.colRight, styles.middleRight)}>
              {data ? (
                <div className={styles.sqftLabel}>{data.sqft}</div>
              ) : null}
            </div>
          </div>
          <div className={cx(styles.bottom, styles.col)}>
            <div className={cx(styles.colLeft, styles.descriptionCol)}>
              {data ? (
                <p className={styles.bottomP}>{data.description}</p>
              ) : null}
            </div>
            <div className={cx(styles.colRight, styles.detailCol)}>
              <div className={styles.bottomRight}>
                <ul>
                  {data
                    ? data.details.map((d, index) => {
                        return (
                          <li
                            key={`stop-details-${tempStopIndex}-${index}`}
                            className={styles.bottomRow}
                          >
                            <div className={styles.bottomValue}>{d}</div>
                          </li>
                        );
                      })
                    : null}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default VideoStopDetails;
